class ecostalSaveCart extends HTMLElement {
  constructor() {
    super();
    const cartButton = this.querySelector('.js-save-cart-button');

    if (cartButton) {
      cartButton.addEventListener('click', () => {
        window.cartSaver.openSelector();
      });
    }
  }
}

customElements.define('ecostal-save-cart', ecostalSaveCart);
